module.exports = __webpack_public_path__ + "img/cloud_2.b0c000b9.png";